import FormLoading from '@ui-framework/components/AdvancedForms/FormLoading';
import { useDataProvider } from '@ui-framework/index';
import { createContext, useContext, useEffect, useMemo, useState } from 'react';

const ServiceProviderLocationNameContext = createContext(null);

function ServiceProviderLocationProvider({
  children,
  pageId = null,
  entityId,
}) {
  const [spLocation, setSPLocation] = useState(null);
  const [loading, setLoading] = useState(true);
  const provider =
    process.env.NODE_ENV === 'development' ? 'sxclServices' : 'default';
  const dataProvider = useDataProvider(provider);

  const fetchServiceProviderLocation = async () => {
    const url = `${dataProvider.getApiUrl()}/sxcl/v1/service-providers/${pageId}/locations/${entityId}`;
    const response = await dataProvider.get(url);

    if (response?.ok && response?.data?.locationName != null) {
      setSPLocation(response.data);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (pageId && entityId) {
      fetchServiceProviderLocation();
    } else {
      setLoading(false);
    }
  }, [pageId, entityId, dataProvider]);

  const locationNameContextValue = useMemo(
    () => ({
      spLocation,
      setSPLocation,
    }),
    [spLocation, setSPLocation],
  );

  if (loading) {
    return <FormLoading>Loading...</FormLoading>;
  }

  return (
    <ServiceProviderLocationNameContext.Provider
      value={locationNameContextValue}>
      {children}
    </ServiceProviderLocationNameContext.Provider>
  );
}

export const useServiceProviderLocation = () => {
  const context = useContext(ServiceProviderLocationNameContext);
  return context;
};

export default ServiceProviderLocationProvider;
